// 直播状态
export const LIVE_STATUS = {
  BEFORE_START: 0, // 未开始
  ING: 1, // 进行中
  END: 2 // 结束
}

// 巡视状态
export const INSPECT_STATUS = {
  ING: 1, // 进行中
  END: 2 // 结束
}

// 导播台，直播布局
export const VIDEO_LAYOUT_LIST = [
  {
    type: 'full_screen',
    typeText: '单画面视图',
    layoutImg: require('@/assets/img/guideStation/layout1.png'),
    layoutParams: [
      {
        layout: 'default',
        streamCount: 1,
        panels: [
          {
            name: 'main'
          }
        ]
      }
    ],
  },
  {
    type: 'sidebar',
    typeText: '侧边栏视图',
    layoutImg: require('@/assets/img/guideStation/layout2.png'),
    layoutParams: [
      {
        layout: 'left_and_narrow_right_top',
        streamCount: 2,
        panels: [
          {
            name: 'left'
          },
          {
            name: 'right_top'
          }
        ]
      },
      {
        layout: 'left_and_narrow_right_all',
        streamCount: 3,
        panels: [
          {
            name: 'left'
          },
          {
            name: 'right_top'
          },
          {
            name: 'right_bottom'
          }
        ]
      }
    ],
  },
  {
    type: 'float',
    typeText: '画中画视图',
    layoutImg: require('@/assets/img/guideStation/layout3.png'),
    layoutParams: [
      {
        layout: 'main_and_float',
        streamCount: 2,
        panels: [
          {
            name: 'main'
          },
          {
            name: 'float'
          }
        ]
      }
    ],
  },
  {
    type: 'grid',
    typeText: '宫格视图',
    layoutImg: require('@/assets/img/guideStation/layout4.png'),
    layoutParams: [
      {
        layout: 'two_panels',
        streamCount: 2,
        panels: [
          {
            name: 'left'
          },
          {
            name: 'right'
          }
        ]
      },
      {
        layout: 'three_panels',
        streamCount: 3,
        panels: [
          {
            name: 'left_top'
          },
          {
            name: 'right_top'
          },
          {
            name: 'middle_bottom'
          },
        ]
      },
      {
        layout: 'four_panels',
        streamCount: 4,
        panels: [
          {
            name: 'left_top'
          },
          {
            name: 'right_top'
          },
          {
            name: 'left_bottom'
          },
          {
            name: 'right_bottom'
          }
        ]
      }
    ],
  },
  {
    type: 'intelligent_following',
    typeText: '智能跟随视图',
    layoutImg: require('@/assets/img/guideStation/layout5.png'),
    layoutParams: [
      {
        layout: 'left_t_right_v',
        streamCount: 2,
        panels: [
          {
            name: 'left_t'
          },
          {
            name: 'right_v'
          }
        ]
      }
    ],
  },
]
